var render = function render(){var _vm=this,_c=_vm._self._c;return _c('authorized-layout',{scopedSlots:_vm._u([{key:"main-content",fn:function(){return [_c('construction-block',{staticClass:"mb-2"},[_c('tab-navigation',{attrs:{"items":_vm.navigationItems}})],1),_c('router-view')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }